export const ANSWERS_RECEIVED = "ANSWERS_RECEIVED";
export const SET_ANSWER = "SET_ANSWER";
